// import React, { useState, useEffect } from 'react';
// import { FormGroupLabel, FormContainer, FormGroup, FormGroupField, } from '@/shared/components/form/FormElements';
// import { Field, Form } from 'react-final-form';
// import { Button } from '@/shared/components/Button';
// import { IoIosRemoveCircle } from 'react-icons/io';
// import Select from 'react-select';
// import {
//   Table, Row, Col, Container, Modal, Form as BootstrapForm,
// } from 'react-bootstrap';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';


// // Styled-components for styling
// const Container = styled.div`
//   background-color: #f7f7f7;
//   min-height: 47vh;
// `;

// const PaxDetailsCardWrapper = styled.div`
//   background-color: #ffffff;
//   border-radius: 8px;
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
//   padding: 20px;
//   width: 100%;
//   max-width: 800px;
//   margin: 0 auto;
// `;

// const FormSection = styled.div`
//   padding-bottom: 15px;
//   margin-bottom: 15px;
//   border-bottom: 1px solid #d1d1d1;
//   max-height: 250px;
//   overflow-y: auto;
// `;

// const ReactSelect = styled(Select)`
//   width: 100%;
//   border-radius: 4px;
//   border: 1px solid #d1d1d1;
//   font-size: 12px;
//   &:hover {
//     border-color: #007bff;
//   }
// `;

// const InputField = styled.input`
//   width: 100%;
//   padding: 8px 10px;
//   border-radius: 4px;
//   border: 1px solid #d1d1d1;
//   font-size: 12px;
//   margin-bottom: 10px;
//   &:focus {
//     border-color: #007bff;
//     outline: none;
//   }
// `;

// const ButtonAdd = styled(Button)`
//   background-color: #007bff;
//   color: white;
//   border: none;
//   padding: 10px 15px;
//   font-size: 14px;
//   border-radius: 4px;
//   transition: background-color 0.3s ease;
//   width: 100%;
//   margin-top: 10px;
//   &:hover {
//     background-color: #0056b3;
//   }
// `;

// const FormGroupLabelStyled = styled(FormGroupLabel)`
//   font-weight: 500;
//   color: #495057;
//   margin-bottom: 5px;
//   font-size: 12px;
// `;

// const FormRow = styled.div`
//   display: flex;
//   gap: 15px;
//   margin-bottom: 15px;
// `;

// const Column = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
// `;

// const ErrorMessage = styled.span`
//   color: red;
//   font-size: 12px;
//   margin-top: -5px;
//   margin-bottom: 5px;
// `;

// const TableContainer = styled.div`
//   max-height: 400px;
//   max-width: 700px;
//   overflow-y: auto;
//   overflow-x: auto;
//   margin: 12px;
// `;

// const AGE_GROUP_OPTIONS = [
//   { value: '1', label: 'Adult' },
//   { value: '2', label: 'Child' },
// ];

// const PaxTable = ({ paxdata, setPaxDetailsHandler }) => {
//   const [itemValue, setItemValue] = useState('');
//   const [emailValue, setEmailValue] = useState('');
//   const [phoneValue, setPhoneValue] = useState('');
//   const [typeSelect, setTypeSelect] = useState(null);
//   const [emailError, setEmailError] = useState('');
//   const [phoneError, setPhoneError] = useState('');
//   const [newPaxData, setNewPaxData] = useState([]);
//   const [initaildataForPaxEdit, setInitaildataForPaxEdit] = useState({});
//   const [openPaxEditModal, setOpenPaxEditModal] = useState(false);
   

//   useEffect(() => {
//     if (paxdata) {
//       setNewPaxData(paxdata);
//     } else {
//       setNewPaxData([]);
//     }
//   }, [paxdata]);

//   const validateEmail = (email) => {
//     const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return regex.test(email);
//   };

//   const validatePhone = (phone) => {
//     const regex = /^\d{12}$/;
//     return regex.test(phone);
//   };

//   const resetForm = () => {
//     setItemValue('');
//     setEmailValue('');
//     setPhoneValue('');
//     setTypeSelect(null);
//     setEmailError('');
//     setPhoneError('');
//   };

//   const handleAddMeal = () => {
//     let hasError = false;

//     // Validate all fields
//     if (!itemValue.trim()) {
//       hasError = true;
//     }

//     if (!typeSelect) {
//       hasError = true;
//     }

//     if (!validateEmail(emailValue)) {
//       setEmailError('Please enter a valid email address.');
//       hasError = true;
//     } else {
//       setEmailError('');
//     }

//     if (!validatePhone(phoneValue)) {
//       setPhoneError('Please enter a valid 12-digit phone number.');
//       hasError = true;
//     } else {
//       setPhoneError('');
//     }

//     if (hasError) {
//       return;
//     }

//     const newPax = {
//       id: new Date().toISOString(),
//       pax_id: 0,
//       pax_name: itemValue,
//       email_id: emailValue,
//       mobile_no: phoneValue,
//       age_group: typeSelect.value, // Store just the value
//       flag: 0,
//     };

//     const updatedPaxData = [...newPaxData, newPax];
//     setNewPaxData(updatedPaxData);
//     setPaxDetailsHandler(updatedPaxData);
    
//     resetForm();
//   };

//   const handleRemovePax = (paxId, isNewPax) => {
//     const updatedPaxData = newPaxData.filter((pax) => {
//       if (isNewPax) {
//         return pax.id !== paxId;
//       }
//       return pax.pax_id !== paxId;
//     });
    
//     setNewPaxData(updatedPaxData);
//     setPaxDetailsHandler(updatedPaxData);
//   };

//   const handleSelectChange = (selectedOption) => {
//     setTypeSelect(selectedOption);
//   };

//   const getAgeGroupLabel = (value) => {
//     const option = AGE_GROUP_OPTIONS.find(opt => opt.value === value);
//     return option ? option.label : 'Unknown';
//   };

//   return (
//     <Container>
//       <PaxDetailsCardWrapper>
//         <FormSection>
//           <FormRow>
//             <Column>
//               <FormGroupLabelStyled>Name</FormGroupLabelStyled>
//               <InputField
//                 type="text"
//                 placeholder="Enter Name"
//                 value={itemValue}
//                 onChange={e => setItemValue(e.target.value)}
//               />
//               <FormGroupLabelStyled>Email</FormGroupLabelStyled>
//               <InputField
//                 type="email"
//                 placeholder="Enter Email"
//                 value={emailValue}
//                 onChange={(e) => {
//                   setEmailValue(e.target.value);
//                   if (emailError && validateEmail(e.target.value)) {
//                     setEmailError('');
//                   }
//                 }}
//               />
//               {emailError && <ErrorMessage>{emailError}</ErrorMessage>}
//             </Column>

//             <Column>
//               <FormGroupLabelStyled>Phone No.</FormGroupLabelStyled>
//               <InputField
//                 type="text"
//                 placeholder="Enter 12-digit phone number"
//                 value={phoneValue}
//                 maxLength={12}
//                 onChange={(e) => {
//                   const onlyDigits = e.target.value.replace(/\D/g, '');
//                   setPhoneValue(onlyDigits);
//                   if (phoneError && validatePhone(onlyDigits)) {
//                     setPhoneError('');
//                   }
//                 }}
//               />
//               {phoneError && <ErrorMessage>{phoneError}</ErrorMessage>}
//               <FormGroupLabelStyled>Type</FormGroupLabelStyled>
//               <Field
//                 name="age_group"
//                 render={({ input }) => (
//                   <ReactSelect
//                     {...input}
//                     name="age_group"
//                     options={AGE_GROUP_OPTIONS}
//                     placeholder="Select Age Group"
//                     value={typeSelect}
//                     onChange={(selectedOption) => {
//                       input.onChange(selectedOption ? selectedOption.value : '');
//                       handleSelectChange(selectedOption);
//                     }}
//                   />
//                 )}
//                 required
//               />
//             </Column>
//           </FormRow>
//           <ButtonAdd onClick={handleAddMeal}>Add Pax</ButtonAdd>
//         </FormSection>
//         <h4>Pax Details</h4>
//         <TableContainer>
//           <table className="table table-striped table-bordered">
//             <thead className="thead-dark">
//               <tr>
//                 <th scope="col">#</th>
//                 <th scope="col">Name</th>
//                 <th scope="col">Email</th>
//                 <th scope="col">Phone Number</th>
//                 <th scope="col">Age Group</th>
//                 <th scope="col">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {newPaxData.map((pax, index) => (
//                 <tr key={pax.id || `pax-${pax.pax_id}-${index}`}>
//                   <th scope="row">{index + 1}</th>
//                   <td>{pax.pax_name}</td>
//                   <td>{pax.email_id}</td>
//                   <td>{pax.mobile_no}</td>
//                   <td>{getAgeGroupLabel(pax.age_group)}</td>
//                   <td>
//                     {pax?.flag === 0 ? (
//                       <Button
//                         type="button"
//                         variant="outline-danger"
//                         size="sm"
//                         onClick={() => handleRemovePax(
//                           pax.pax_id === 0 ? pax.id : pax.pax_id, 
//                           pax.pax_id === 0,
//                         )}
//                       >
//                         <IoIosRemoveCircle />
//                       </Button>
//                     ) : (
//                       <Button 
//                         variant="primary" 
//                         size="sm" 
//                         title="Pax is used somewhere can't be deleted.."
//                       >
//                         Used
//                       </Button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </TableContainer>
//       </PaxDetailsCardWrapper>
//       <Modal show={openPaxEditModal} onHide={() => setOpenPaxEditModal(false)} centered size="md">
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Pax</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={editPaxhandler} initialValues={initaildataForPaxEdit}>
//             {({ handleSubmit }) => (
//               <FormContainer onSubmit={handleSubmit}>
//                 <FormGroup>
//                   <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                   <FormGroupField>
//                     <Field
//                       name="pax_id"
//                       style={{ display: 'none' }}
//                       component="input"
//                       type="text"
//                       placeholder="Pax Name"
//                     />
//                     <Field name="pax_name" component="input" type="text" placeholder="Pax Name" />
//                   </FormGroupField>
//                 </FormGroup>
//                 <FormGroup>
//                   <FormGroupLabel>Pax Email<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                   <FormGroupField>
//                     <Field name="email_id" component="input" type="email" placeholder="Pax Email" />
//                   </FormGroupField>
//                 </FormGroup>
//                 <FormGroup>
//                   <FormGroupLabel>Pax Mobile no.<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                   <FormGroupField>
//                     <Field
//                       name="mobile_no"
//                       component="input"
//                       type="number"
//                       maxLength={12}
//                       placeholder="Pax Mobile no"
//                     />
//                   </FormGroupField>
//                 </FormGroup>
//                 <FormGroup>
//                   <FormGroupLabel>Select Group<span style={{ color: 'red' }}>*</span></FormGroupLabel>
//                   <Field
//                     name="age_group"
//                     render={({ input, meta }) => (
//                       <Select
//                         {...input}
//                         name="age_group"
//                         className="react-select"
//                         classNamePrefix="react-select"
//                         options={groupOptions}
//                         value={groupOptions.find(option => option.value === input.value) || null}
//                         onChange={option => input.onChange(option?.value)}
//                       />
//                       )}
//                   />
//                 </FormGroup>
//                 <Button type="submit">Submit</Button>
//               </FormContainer>
//             )}
//           </Form>
//         </Modal.Body>
//       </Modal>
//     </Container>
//   );
// };

// PaxTable.propTypes = {
//   paxdata: PropTypes.arrayOf(
//     PropTypes.shape({
//       pax_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//       pax_name: PropTypes.string.isRequired,
//       mobile_no: PropTypes.string.isRequired,
//       email_id: PropTypes.string.isRequired,
//       age_group: PropTypes.string.isRequired,
//       flag: PropTypes.number,
//     }),
//   ),
//   setPaxDetailsHandler: PropTypes.func.isRequired,
// };

// PaxTable.defaultProps = {
//   paxdata: [],
// };

// export default PaxTable;

import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { Field, Form } from 'react-final-form';
import Select from 'react-select';
// Import Bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Table, Button, Row, Col, Container, Modal, Form as BootstrapForm,
} from 'react-bootstrap';
 
// Import Form Elements (Ensure path is correct)
import {
  FormContainer, FormGroup, FormGroupField, FormGroupLabel,
} from '@/shared/components/form/FormElements';
import { set } from 'date-fns';
import { AuthContext } from '../../../../../context/AuthContext';
import { GlobalContext } from '../../../../../context/GlobalContext';
 
const PaxTable = ({ paxdata, setPaxDetailsHandler }) => {
  const [openPaxEditModal, setOpenPaxEditModal] = useState(false);
  const [itemValue, setItemValue] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [phoneValue, setPhoneValue] = useState('');
  const [ageGroupValue, setAgeGroupValue] = useState('');
  const [newPaxData, setNewPaxData] = useState(paxdata);
  const [emailError, setEmailError] = useState('');
  const [initaildataForPaxEdit, setInitaildataForPaxEdit] = useState({});
  const { apiGlobal } = useContext(GlobalContext);
  const { userId } = useContext(AuthContext);
 
  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };
 
  const handleEmailChange = (e) => {
    const email = e.target.value;
    setEmailValue(email);
 
    if (!email) {
      setEmailError('Email is required');
    } else if (!validateEmail(email)) {
      setEmailError('Invalid email format');
    } else {
      setEmailError('');
    }
  };
 
  useEffect(() => {
    setNewPaxData(paxdata);
  }, [paxdata]);
 
  const handleAddPax = () => {
    if (!itemValue || !emailValue || !phoneValue || !ageGroupValue) {
      toast.error('Some fields are empty!');
      return;
    }
 
    const newPax = {
      id: new Date().toISOString(),
      pax_id: 0,
      flag: 0,
      pax_name: itemValue,
      email_id: emailValue,
      mobile_no: phoneValue,
      age_group: ageGroupValue,
    };
 
    const updatedPaxData = [...newPaxData, newPax];
    setNewPaxData(updatedPaxData);
    setPaxDetailsHandler(updatedPaxData);
 
    setItemValue('');
    setEmailValue('');
    setPhoneValue('');
    setAgeGroupValue('');
  };
 
  const handleRemovePax = (id) => {
    const updatedPaxData = newPaxData.filter(pax => pax.pax_id !== id);
    setNewPaxData(updatedPaxData);
    setPaxDetailsHandler(updatedPaxData);
  };
 
  const editPaxhandler = async (values) => {
      // console.log(JSON.stringify(values, null, 2));
      const formdata = new FormData();
      formdata.append('user_id', userId);
      formdata.append('id', values.pax_id);
      formdata.append('pax_name', values.pax_name);
      formdata.append('email_id', values.email_id);
      formdata.append('mobile_no', values.mobile_no);
      formdata.append('age_group', values.age_group);
 
 
      try {
         const url = await fetch(`${apiGlobal}/agent/pax_edit.php`, {
          method: 'POST',
          body: formdata,
         });
         const data = await url.json();
        if (data.status && data.message === 'Record updated successfully.') {
          toast.success('Pax updated successfully!');
          setOpenPaxEditModal(false);
             // ✅ Update edited Pax in local state
      const updatedList = newPaxData.map(pax => (pax.pax_id === values.pax_id
          ? { ...pax, ...values }
          : pax));
 
      setNewPaxData(updatedList);
      setPaxDetailsHandler(updatedList); // Optional: inform parent
          setInitaildataForPaxEdit({});
        } else {
          toast.error('Pax not updated!');
        }
      } catch (error) {
        console.log(error);
      }
  };
 
  const groupOptions = [
    { value: '1', label: 'Adult' },
    { value: '2', label: 'Child' },
  ];
 
  const editpaxtranport = (paxid, paxname, emailid, mobileno, agegroup) => {
    setOpenPaxEditModal(true);
    setInitaildataForPaxEdit({
      pax_id: paxid,
      pax_name: paxname,
      email_id: emailid,
      mobile_no: mobileno,
      age_group: agegroup,
    });
  };
 
 
 
  return (
    <Container className="mt-4">
      <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <Table
          striped
          bordered
          hover 
          className="table-sm align-middle text-nowrap"
          
        >
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Age Group</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {newPaxData.map((pax, index) => (
              <tr key={pax.pax_id}>
                <td>{index + 1}</td>
                <td>{pax.pax_name}</td>
                <td>{pax.email_id || 'NA'}</td>
                <td>{pax.mobile_no || 'NA'}</td>
                <td>{pax.age_group === '1' ? 'Adult' : 'Child'}</td>
                <td style={{ display: 'flex', gap: '5px' }}>
                  {pax.flag === 0 && (
                  <Button variant="danger" size="sm" onClick={() => handleRemovePax(pax.pax_id)}>
                    Remove
                  </Button>
                )}
                  {pax.flag === 1 && (
                  <Button variant="primary" size="sm" disabled>
                    Used
                  </Button>
                )}
               
 
                  {pax.pax_id !== 0 && (
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => editpaxtranport(
pax.pax_id,
 pax.pax_name,
pax.email_id,
pax.mobile_no,
pax.age_group,
)}
                  >
                    Edit
                  </Button>
                )}
               
                </td>
              </tr>
          ))}
          </tbody>
        </Table>
      </div>
      
 
      <h4 className="mt-4 text-center">Add More Pax</h4>
      <BootstrapForm className="p-3 border rounded bg-light">
        <Row className="mb-3">
          <Col md={6}>
            <BootstrapForm.Group>
              <BootstrapForm.Label>Name</BootstrapForm.Label>
              <BootstrapForm.Control
                type="text"
                placeholder="Enter Name"
                value={itemValue}
                onChange={e => setItemValue(e.target.value)}
              />
            </BootstrapForm.Group>
          </Col>
          <Col md={6}>
            <BootstrapForm.Group>
              <BootstrapForm.Label>Email</BootstrapForm.Label>
              <BootstrapForm.Control
                type="email"
                placeholder="Enter Email"
                value={emailValue}
                onChange={handleEmailChange}
                isInvalid={!!emailError}
              />
              {emailError
              && <BootstrapForm.Control.Feedback type="invalid">{emailError}</BootstrapForm.Control.Feedback>}
            </BootstrapForm.Group>
          </Col>
        </Row>
 
        <Row className="mb-3">
          <Col md={6}>
            <BootstrapForm.Group>
              <BootstrapForm.Label>Phone No.</BootstrapForm.Label>
              <BootstrapForm.Control
                type="tel"
                placeholder="Enter  Phone No."
                value={phoneValue}
                onChange={(e) => {
                  const input = e.target.value.replace(/\D/g, '');
                  if (input.length <= 10) setPhoneValue(input);
                }}
                maxLength={10}
                required
              />
              {/* <BootstrapForm.Text className="text-muted">
                Please enter a 12-digit phone number.
              </BootstrapForm.Text> */}
            </BootstrapForm.Group>
          </Col>
          <Col md={6}>
            <BootstrapForm.Group>
              <BootstrapForm.Label>Age Group</BootstrapForm.Label>
              <BootstrapForm.Select value={ageGroupValue} onChange={e => setAgeGroupValue(e.target.value)}>
                <option value="">Select Age Group</option>
                <option value="1">Adult</option>
                <option value="2">Child</option>
              </BootstrapForm.Select>
            </BootstrapForm.Group>
          </Col>
        </Row>
 
        <div className="text-center mt-3">
          <Button variant="primary" size="lg" onClick={handleAddPax}>
            Add Pax
          </Button>
        </div>
      </BootstrapForm>
 
      <Modal show={openPaxEditModal} onHide={() => setOpenPaxEditModal(false)} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>Edit Pax</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={editPaxhandler} initialValues={initaildataForPaxEdit}>
            {({ handleSubmit }) => (
              <FormContainer onSubmit={handleSubmit}>
                <FormGroup>
                  <FormGroupLabel>Name<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                  <FormGroupField>
                    <Field
                      name="pax_id"
                      style={{ display: 'none' }}
                      component="input"
                      type="text"
                      placeholder="Pax Name"
                    />
                    <Field name="pax_name" component="input" type="text" placeholder="Pax Name" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Pax Email<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                  <FormGroupField>
                    <Field name="email_id" component="input" type="email" placeholder="Pax Email" />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Pax Mobile no.<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                  <FormGroupField>
                    <Field
                      name="mobile_no"
                      component="input"
                      type="number"
                      maxLength={12}
                      placeholder="Pax Mobile no"
                    />
                  </FormGroupField>
                </FormGroup>
                <FormGroup>
                  <FormGroupLabel>Select Group<span style={{ color: 'red' }}>*</span></FormGroupLabel>
                  <Field
                    name="age_group"
                    render={({ input, meta }) => (
                      <Select
                        {...input}
                        name="age_group"
                        className="react-select"
                        classNamePrefix="react-select"
                        options={groupOptions}
                        value={groupOptions.find(option => option.value === input.value) || null}
                        onChange={option => input.onChange(option?.value)}
                      />
                      )}
                  />
                </FormGroup>
                <Button type="submit">Submit</Button>
              </FormContainer>
            )}
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};
 
PaxTable.propTypes = {
  paxdata: PropTypes.arrayOf.isRequired,
  setPaxDetailsHandler: PropTypes.func.isRequired,
};
 
export default PaxTable;

// import React, { useState, useEffect } from 'react';
// import { FormGroupLabel } from '@/shared/components/form/FormElements';
// import { Field } from 'react-final-form';
// import { Button } from '@/shared/components/Button';
// import { IoIosRemoveCircle } from 'react-icons/io';
// import Select from 'react-select';
// import PropTypes from 'prop-types';
// import { Table } from '@/shared/components/TableElements';
// import styled from 'styled-components';

// // Styled-components for styling
// const Container = styled.div`
//   background-color: #f7f7f7;
//   min-height: 47vh;
// `;

// const PaxDetailsCardWrapper = styled.div`
//   background-color: #ffffff;
//   border-radius: 8px;
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
//   padding: 20px;
//   width: 100%;
//   max-width: 800px;
//   margin: 0 auto;
// `;

// const FormSection = styled.div`
//   padding-bottom: 15px;
//   margin-bottom: 15px;
//   border-bottom: 1px solid #d1d1d1;
//   max-height: 250px;
//   overflow-y: auto;
// `;

// const TableWrapper = styled.div`
//   max-height: 300px;
//   overflow-y: auto;
//   margin-top: 20px;
// `;

// const ReactSelect = styled(Select)`
//   width: 100%;
//   border-radius: 4px;
//   border: 1px solid #d1d1d1;
//   font-size: 12px;
//   &:hover {
//     border-color: #007bff;
//   }
// `;

// const InputField = styled.input`
//   width: 100%;
//   padding: 8px 10px;
//   border-radius: 4px;
//   border: 1px solid #d1d1d1;
//   font-size: 12px;
//   margin-bottom: 10px;
//   &:focus {
//     border-color: #007bff;
//     outline: none;
//   }
// `;

// const ButtonRemove = styled(Button)`
//   color: red;
//   background: none;
//   border: none;
//   font-size: 16px;
//   cursor: pointer;
//   transition: transform 0.2s ease-in-out;
//   &:hover {
//     transform: scale(1.1);
//   }
// `;

// const ButtonAdd = styled(Button)`
//   background-color: #007bff;
//   color: white;
//   border: none;
//   padding: 10px 15px;
//   font-size: 14px;
//   border-radius: 4px;
//   transition: background-color 0.3s ease;
//   width: 100%;
//   margin-top: 10px;
//   &:hover {
//     background-color: #0056b3;
//   }
// `;

// const FormGroupLabelStyled = styled(FormGroupLabel)`
//   font-weight: 500;
//   color: #495057;
//   margin-bottom: 5px;
//   font-size: 12px;
// `;

// const FormRow = styled.div`
//   display: flex;
//   gap: 15px;
//   margin-bottom: 15px;
// `;

// const Column = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
// `;

// const PaxTable = ({ paxdata, setPaxDetailsHandler }) => {
//   const [itemValue, setItemValue] = useState('');
//   const [emailValue, setEmailValue] = useState('');
//   const [phoneValue, setPhoneValue] = useState('');
//   const [typeSelect, setTypeSelect] = useState(null);
//   const [emailError, setEmailError] = useState('');
//   const [phoneError, setPhoneError] = useState('');
//   const [newPaxData, setNewPaxData] = useState([]);

//     useEffect(() => {
//     if (paxdata) {
//     setNewPaxData(paxdata);
//     } else {
//       setNewPaxData([]);
//     }
//   }, [paxdata]);

//   const validateEmail = (email) => {
//     const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return regex.test(email);
//   };

//   const validatePhone = (phone) => {
//     const regex = /^\d{12}$/;
//     return regex.test(phone);
//   };

//   const handleAddMeal = () => {
//     if (!itemValue.trim() || !typeSelect) {
//       alert('Please fill in all fields.');
//       return;
//     }

//     if (!validateEmail(emailValue)) {
//       setEmailError('Please enter a valid email address.');
//       return;
//     } 
//       setEmailError('');
    

//     if (!validatePhone(phoneValue)) {
//       setPhoneError('Please enter a valid 12-digit phone number.');
//       return;
//     } 
//       setPhoneError('');

//       console.log(typeSelect);
    

//       const newPax = {
//               id: new Date().toISOString(),
//               pax_id: 0,
//               pax_name: itemValue,
//               email_id: emailValue,
//               mobile_no: phoneValue,
//               age_group: typeSelect,
//               flag: 0,
//             };

//     const updatedPaxData = [...newPaxData, newPax];
//         setNewPaxData(updatedPaxData);
//         setPaxDetailsHandler(updatedPaxData);

//     setItemValue('');
//     setEmailValue('');
//     setPhoneValue('');
//     setTypeSelect(null);
//   };

//   // index - 0 for new pax 1 for exisitng pax
//   const handleRemovePax = (paxId, index) => {
//     // eslint-disable-next-line
//     const updatedPaxData = newPaxData.filter(pax => index === 0 ? pax.id : pax.pax_id !== paxId);
//         setNewPaxData(updatedPaxData);
//         setPaxDetailsHandler(updatedPaxData);
//   };

//   const handleSelectChange = (selectedOption) => {
//     setTypeSelect(selectedOption);
//   };

//   return (
//     <Container>
//       <PaxDetailsCardWrapper>
//         <FormSection>
//           <FormRow>
//             <Column>
//               <FormGroupLabelStyled>Name</FormGroupLabelStyled>
//               <InputField
//                 type="text"
//                 placeholder="Enter Name"
//                 value={itemValue}
//                 onChange={e => setItemValue(e.target.value)}
//               />
//               <FormGroupLabelStyled>Email</FormGroupLabelStyled>
//               <InputField
//                 type="email"
//                 placeholder="Enter Email"
//                 value={emailValue}
//                 onChange={(e) => {
//                   setEmailValue(e.target.value);
//                   if (!validateEmail(e.target.value)) {
//                     setEmailError('Please enter a valid email address.');
//                   } else {
//                     setEmailError('');
//                   }
//                 }}
//               />
//               {emailError && <span style={{ color: 'red', fontSize: '12px' }}>{emailError}</span>}
//             </Column>

//             <Column>
//               <FormGroupLabelStyled>Phone No.</FormGroupLabelStyled>
//               <InputField
//                 type="text"
//                 placeholder="Enter 12-digit phone number"
//                 value={phoneValue}
//                 maxLength={12}
//                 onChange={(e) => {
//                   const onlyDigits = e.target.value.replace(/\D/g, '');
//                   setPhoneValue(onlyDigits);
//                   if (!validatePhone(onlyDigits)) {
//                     setPhoneError('Please enter a valid 12-digit phone number.');
//                   } else {
//                     setPhoneError('');
//                   }
//                 }}
//               />
//               {phoneError && <span style={{ color: 'red', fontSize: '12px' }}>{phoneError}</span>}
//               <FormGroupLabelStyled>Type</FormGroupLabelStyled>
//               <Field
//                 name="age_group"
//                 render={({ input }) => (
//                   <ReactSelect
//                     {...input}
//                     name="age_group"
//                     options={[
//                       { value: '1', label: 'Adult' },
//                       { value: '2', label: 'Child' },
//                     ]}
//                     placeholder="Select Age Group"
//                     value={typeSelect}
//                     onChange={(selectedOption) => {
//                       input.onChange(selectedOption ? selectedOption.value : '');
//                       handleSelectChange(selectedOption);
//                     }}
//                   />
//                 )}
//                 required
//               />
//             </Column>
//           </FormRow>
//           <ButtonAdd onClick={handleAddMeal}>Add Pax</ButtonAdd>
//         </FormSection>
//         <h4>Pax Details</h4>
//         <div 
//           style={{ 
//           maxHeight: '400px', 
//           maxWidth: '700px', 
//           overflowY: 'auto', 
//           overflowX: 'auto',
//           margin: '12px',
//           }}
//         > 
//           <table className="table table-striped table-bordered">
//             <thead className="thead-dark">
//               <tr>
//                 <th scope="col">#</th>
//                 <th scope="col">Name</th>
//                 <th scope="col">Email</th>
//                 <th scope="col">Phone Number</th>
//                 <th scope="col">Age Group</th>
//                 <th scope="col">Actions</th> {/* Added column for actions */}
//               </tr>
//             </thead>
//             <tbody>
//               {newPaxData.map((pax, index) => (
//                 // eslint-disable-next-line
//                 <tr key={index}>
//                   <th scope="row">{index + 1}</th>
//                   <td>{pax.pax_name}</td>
//                   <td>{pax.email_id}</td>
//                   <td>{pax.mobile_no}</td>
//                   <td>{pax.age_group === '1' ? 'Adult' : 'Child'}</td>
//                   <td>
//                     {pax?.flag === 0 ? (
//                       <Button
//                         type="button"
//                         variant="outline-danger"
//                         size="sm"
//                         onClick={() => handleRemovePax(pax.pax_id === 0 ? pax.id 
//                           : pax.pax_id, pax.pax_id === 0 ? 0 : 1)}
//                       >
//                         <IoIosRemoveCircle />
//                       </Button>
//                     ) : (
//                       <Button variant="primary" size="sm" title="Pax is used somewhere can't be deleted..">
//                         Used
//                       </Button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
       

       
//       </PaxDetailsCardWrapper>
//     </Container>
//   );
// };

// PaxTable.propTypes = {
//   paxdata: PropTypes.arrayOf(
//     PropTypes.shape({
//       pax_id: PropTypes.string.isRequired, // Use pax_id as unique identifier
//       pax_name: PropTypes.string.isRequired,
//       mobile_no: PropTypes.string.isRequired,
//       email_id: PropTypes.string.isRequired,
//       age_group: PropTypes.string.isRequired,
//     }),
//   ).isRequired,
//   setPaxDetailsHandler: PropTypes.func.isRequired,
// };

// export default PaxTable;

// import React, { useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
// import toast from 'react-hot-toast';
// import { Field } from 'react-final-form';
// import Select from 'react-select';
// import {
//  Table, Button, Form, Row, Col, Container, 
// } from 'react-bootstrap';
// import { FormGroupLabel } from '@/shared/components/form/FormElements';
// import styled from 'styled-components';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import PaxDetailsCard from '../../../Meal/component/Booking/components/PaxDetailsCard';

//  const FormSection = styled.div`
//    padding-bottom: 15px;
//    margin-bottom: 15px;
//    border-bottom: 1px solid #d1d1d1;
//    max-height: 250px;
//    overflow-y: auto;
//  `;

//  const ReactSelect = styled(Select)`
//    width: 100%;
//    border-radius: 4px;
//    border: 1px solid #d1d1d1;
//    font-size: 12px;
//    &:hover {
//      border-color: #007bff;
//    }
//  `;

//  const FormRow = styled.div`
//    display: flex;
//    gap: 15px;
//    margin-bottom: 15px;
//  `;

//  const Column = styled.div`
//    flex: 1;
//    display: flex;
//    flex-direction: column;
//  `;

//  const FormGroupLabelStyled = styled(FormGroupLabel)`
//    font-weight: 500;
//    color: #495057;
//    margin-bottom: 5px;
//    font-size: 12px;
//  `;

//  const InputField = styled.input`
//    width: 100%;
//    padding: 8px 10px;
//    border-radius: 4px;
//    border: 1px solid #d1d1d1;
//    font-size: 12px;
//    margin-bottom: 10px;
//    &:focus {
//      border-color: #007bff;
//      outline: none;
//    }
//  `;

//  const ButtonAdd = styled(Button)`
//   background-color: #007bff;
//   color: white;
//   border: none;
//   padding: 10px 15px;
//   font-size: 14px;
//   border-radius: 4px;
//   transition: background-color 0.3s ease;
//   width: 100%;
//   margin-top: 10px;
//   &:hover {
//     background-color: #0056b3;
//   }
// `;

// const PaxTable = ({ paxdata, setPaxDetailsHandler }) => {
//   const [itemValue, setItemValue] = useState('');
//   const [emailValue, setEmailValue] = useState('');
//   const [phoneValue, setPhoneValue] = useState('');
//   const [ageGroupValue, setAgeGroupValue] = useState('');
//   const [typeSelect, setTypeSelect] = useState(null);
//   const [newPaxData, setNewPaxData] = useState([]);
//   const [emailError, setEmailError] = useState('');
//   const [phoneError, setPhoneError] = useState('');

//   useEffect(() => {
//     if (paxdata) {
//     setNewPaxData(paxdata);
//     } else {
//       setNewPaxData([]);
//     }
//   }, [paxdata]);

//   const validatePhone = (phone) => {
//     const regex = /^\d{12}$/;
//     return regex.test(phone);
//   };

// // Utility function to validate email
// const validateEmail = (email) => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   return emailRegex.test(email);
// };

// // Utility function to validate phone number
// const validatePhoneNumber = (phone) => {
//   const phoneRegex = /^\+?[1-9]\d{1,14}$/; // E.164 format
//   return phoneRegex.test(phone);
// };
//   const handleAddPax = () => {
//     if (!itemValue || !emailValue || !phoneValue || !ageGroupValue) {
//       toast.error('Some fields are empty!');
//       return;
//     }
//     if (!validateEmail(emailValue)) {
//       toast.error('Invalid email format!');
//       return;
//     }
  
  
//     if (!validatePhoneNumber(phoneValue)) {
//       toast.error('Invalid phone number format!');
//       return;
//     }

//     const newPax = {
//       id: new Date().toISOString(),
//       pax_id: 0,
//       pax_name: itemValue,
//       email_id: emailValue,
//       mobile_no: phoneValue,
//       age_group: ageGroupValue,
//       flag: 0,
//     };

//     const updatedPaxData = [...newPaxData, newPax];
//     setNewPaxData(updatedPaxData);
//     setPaxDetailsHandler(updatedPaxData);

//     setItemValue('');
//     setEmailValue('');
//     setPhoneValue('');
//     setAgeGroupValue('');
//   };

//   const handleRemovePax = (id) => {
//     const updatedPaxData = newPaxData.filter(pax => pax.pax_id !== id);
//     setNewPaxData(updatedPaxData);
//     setPaxDetailsHandler(updatedPaxData);
//   };

//   const handleSelectChange = (selectedOption) => {
//     setTypeSelect(selectedOption);
//   };
  

//   return (
//     <Container className="mt-4">
//       <h4 className="mt-4 text-center">Add More Pax</h4>
//       <Form className="p-3 border rounded bg-light">
//         <Row className="mb-3">
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter Name"
//                 value={itemValue}
//                 onChange={e => setItemValue(e.target.value)}
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label>Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 placeholder="Enter Email"
//                 value={emailValue}
//                 onChange={e => setEmailValue(e.target.value)}
//               />
//             </Form.Group>
//           </Col>
//         </Row>

//         <Row className="mb-3">
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label>Phone No.</Form.Label>
//               <Form.Control
//                 type="tel"
//                 placeholder="Enter Phone No."
//                 value={phoneValue}
//                 onChange={e => setPhoneValue(e.target.value)}
//                 maxLength={12} // Prevents entering more than 10 digits
//               />
//             </Form.Group>
//           </Col>
//           <Col md={6}>
//             <Form.Group>
//               <Form.Label>Age Group</Form.Label>
//               <Form.Select value={ageGroupValue} onChange={e => setAgeGroupValue(e.target.value)}>
//                 <option value="">Select Age Group</option>
//                 <option value="1">Adult</option>
//                 <option value="2">Child</option>
//               </Form.Select>
//             </Form.Group>
//           </Col>
//         </Row>

//         <div className="text-center mt-3">
//           <Button variant="primary" size="lg" onClick={handleAddPax}>
//             Add Pax
//           </Button>
//         </div>
//       </Form>
//       {/* <FormSection>
//         <FormRow>
//           <Column>
//             <FormGroupLabelStyled>Name</FormGroupLabelStyled>
//             <InputField
//               type="text"
//               placeholder="Enter Name"
//               value={itemValue}
//               onChange={e => setItemValue(e.target.value)}
//             />
//             <FormGroupLabelStyled>Email</FormGroupLabelStyled>
//             <InputField
//               type="email"
//               placeholder="Enter Email"
//               value={emailValue}
//               onChange={(e) => {
//                 setEmailValue(e.target.value);
//                 if (!validateEmail(e.target.value)) {
//                   setEmailError('Please enter a valid email address.');
//                 } else {
//                   setEmailError('');
//                 }
//               }}
//             />
//             {emailError && <span style={{ color: 'red', fontSize: '12px' }}>{emailError}</span>}
//           </Column>

//           <Column>
//             <FormGroupLabelStyled>Phone No.</FormGroupLabelStyled>
//             <InputField
//               type="text"
//               placeholder="Enter 12-digit phone number"
//               value={phoneValue}
//               maxLength={12}
//               onChange={(e) => {
//                 const onlyDigits = e.target.value.replace(/\D/g, '');
//                 setPhoneValue(onlyDigits);
//                 if (!validatePhone(onlyDigits)) {
//                   setPhoneError('Please enter a valid 12-digit phone number.');
//                 } else {
//                   setPhoneError('');
//                 }
//               }}
//             />
//             {phoneError && <span style={{ color: 'red', fontSize: '12px' }}>{phoneError}</span>}
//             <FormGroupLabelStyled>Type</FormGroupLabelStyled>
//             <Field
//               name="age_group"
//               render={({ input }) => (
//                 <ReactSelect
//                   {...input}
//                   name="age_group"
//                   options={[
//                     { value: '1', label: 'Adult' },
//                     { value: '2', label: 'Child' },
//                   ]}
//                   placeholder="Select Age Group"
//                   value={typeSelect}
//                   onChange={(selectedOption) => {
//                     input.onChange(selectedOption ? selectedOption.value : '');
//                     handleSelectChange(selectedOption);
//                   }}
//                 />
//               )}
//               required
//             />
//             <ButtonAdd onClick={handleAddPax}>Add Pax</ButtonAdd>
//           </Column>
//         </FormRow>
//       </FormSection> */}
//       <div 
//         style={{ 
//         maxHeight: '400px', 
//         maxWidth: '700px', 
//         overflowY: 'auto', 
//         overflowX: 'auto',
//         margin: '12px',
//         }}
//       >
//         <Table responsive="sm" striped bordered hover>
//           <thead className="thead-dark">
//             <tr>
//               <th>#</th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Phone Number</th>
//               <th>Age Group</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {newPaxData.map((pax, index) => (
//               <tr key={pax?.pax_id}>
//                 <td>{index + 1}</td>
//                 <td>{pax?.pax_name}</td>
//                 <td>{pax?.email_id}</td>
//                 <td>{pax?.mobile_no}</td>
//                 <td>{pax?.age_group === '1' ? 'Adult' : 'Child'}</td>
//                 <td>
//                   {pax?.flag === 0 ? (
//                     <Button variant="danger" size="sm" onClick={() => handleRemovePax(pax?.pax_id)}>
//                       Remove
//                     </Button>
//                   ) : (
//                     <Button variant="primary" size="sm" disabled>
//                       Used
//                     </Button>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       </div>

     
//     </Container>
//   );
// };

// PaxTable.propTypes = {
//   paxdata: PropTypes.arrayOf(
//     PropTypes.shape({
//       pax_id: PropTypes.string.isRequired,
//       pax_name: PropTypes.string.isRequired,
//       mobile_no: PropTypes.string.isRequired,
//       email_id: PropTypes.string.isRequired,
//       age_group: PropTypes.string.isRequired,
//       flag: PropTypes.number.isRequired,
//     }),
//   ).isRequired,
//   setPaxDetailsHandler: PropTypes.func.isRequired,
// };


// export default PaxTable;



// // code for re-review 
// // import React, { useState } from 'react';
// // import PropTypes from 'prop-types';
// // import 'bootstrap/dist/css/bootstrap.min.css';

// // // Your existing PaxTable component
// // const PaxTable = ({ paxdata, setPaxDetailsHandler }) => {
// //   const [itemValue, setItemValue] = useState('');
// //   const [emailValue, setEmailValue] = useState('');
// //   const [phoneValue, setPhoneValue] = useState('');
// //   const [ageGroupValue, setAgeGroupValue] = useState('');
// //   const [newPaxData, setNewPaxData] = useState(paxdata);

// //   const handleAddPax = () => {
// //     const newPax = {
// //       pax_id: new Date().toISOString(), // Generate a unique ID using timestamp
// //       pax_name: itemValue,
// //       email_id: emailValue,
// //       mobile_no: phoneValue,
// //       age_group: ageGroupValue,
// //     };

// //     const updatedPaxData = [...newPaxData, newPax];
// //     setNewPaxData(updatedPaxData);
// //     setPaxDetailsHandler(updatedPaxData);

// //     // Reset form fields after adding Pax
// //     setItemValue('');
// //     setEmailValue('');
// //     setPhoneValue('');
// //     setAgeGroupValue('');
// //   };

// //   const handleRemovePax = (id) => {
// //     // Filter out the Pax entry by its pax_id
// //     const updatedPaxData = newPaxData.filter(pax => pax.pax_id !== id);
// //     setNewPaxData(updatedPaxData);
// //     setPaxDetailsHandler(updatedPaxData);
// //   };


// //   return (
// //     <div className="container mt-5">
// //       {/* Table displaying the Pax data */}
// //       <table className="table table-striped table-bordered">
// //         <thead className="thead-dark">
// //           <tr>
// //             <th scope="col">#</th>
// //             <th scope="col">Name</th>
// //             <th scope="col">Email</th>
// //             <th scope="col">Phone Number</th>
// //             <th scope="col">Age Group</th>
// //             <th scope="col">Actions</th> {/* Added column for actions */}
// //           </tr>
// //         </thead>
// //         <tbody>
// //           {newPaxData.map((pax, index) => (
// //             <tr key={pax.pax_id}>
// //               <th scope="row">{index + 1}</th>
// //               <td>{pax.pax_name}</td>
// //               <td>{pax.email_id}</td>
// //               <td>{pax.mobile_no}</td>
// //               <td>{pax.age_group === '1' ? 'Adult' : 'Child'}</td>
// //               <td>
// //                 <button
// //                   type="button"
// //                   className="btn btn-danger"
// //                   onClick={() => handleRemovePax(pax.pax_id)} // Call handleRemovePax with Pax ID
// //                 >
// //                   Remove
// //                 </button>
// //               </td>
// //             </tr>
// //           ))}
// //         </tbody>
// //       </table>

// //       {/* Form for adding more Pax */}
// //       <div className="mt-4">
// //         <h4>Add More Pax</h4>
// //         <div className="form-section">
// //           <div className="form-row">
// //             {/* Column for name and email */}
// //             <div className="col-md-6">
// //               <div className="form-group">
// //                 <label htmlFor="paxName">Name</label>
// //                 <input
// //                   id="paxName"
// //                   type="text"
// //                   className="form-control"
// //                   placeholder="Enter Name"
// //                   value={itemValue}
// //                   onChange={e => setItemValue(e.target.value)}
// //                 />
// //               </div>
// //               <div className="form-group">
// //                 <label htmlFor="paxEmail">Email</label>
// //                 <input
// //                   id="paxEmail"
// //                   type="email"
// //                   className="form-control"
// //                   placeholder="Enter Email"
// //                   value={emailValue}
// //                   onChange={e => setEmailValue(e.target.value)}
// //                 />
// //               </div>
// //             </div>

// //             {/* Column for phone number and age group */}
// //             <div className="col-md-6">
// //               <div className="form-group">
// //                 <label htmlFor="paxPhone">Phone No.</label>
// //                 <input
// //                   id="paxPhone"
// //                   type="number"
// //                   className="form-control"
// //                   placeholder="Enter Phone No."
// //                   value={phoneValue}
// //                   onChange={e => setPhoneValue(e.target.value)}
// //                 />
// //               </div>
// //               <div className="form-group">
// //                 <label htmlFor="paxAgeGroup">Age Group</label>
// //                 <select
// //                   id="paxAgeGroup"
// //                   className="form-control"
// //                   value={ageGroupValue}
// //                   onChange={e => setAgeGroupValue(e.target.value)}
// //                 >
// //                   <option value="">Select Age Group</option>
// //                   <option value="1">Adult</option>
// //                   <option value="2">Child</option>
// //                 </select>
// //               </div>
// //             </div>
// //           </div>

// //           <button
// //             type="button"
// //             className="btn btn-primary mt-3"
// //             onClick={handleAddPax}
// //           >
// //             Add Pax
// //           </button>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // PaxTable.propTypes = {
// //   paxdata: PropTypes.arrayOf(
// //     PropTypes.shape({
// //       pax_id: PropTypes.string.isRequired, // Use pax_id as unique identifier
// //       pax_name: PropTypes.string.isRequired,
// //       mobile_no: PropTypes.string.isRequired,
// //       email_id: PropTypes.string.isRequired,
// //       age_group: PropTypes.string.isRequired,
// //     }),
// //   ).isRequired,
// //   setPaxDetailsHandler: PropTypes.func.isRequired,
// // };

// // export default PaxTable;

